// Browsers compile `pattern` with the `v` flag, which rejects an unescaped `-`
// inside a character class and silently disables the whole pattern.
export const EMAIL_PATTERN =
	'[a-zA-Z0-9._%+\\-]+@[a-zA-Z0-9.\\-]+\\.[a-zA-Z]{2,}';
